import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.975 3.911h-2v-.978c0-1.662-1.3-2.933-3-2.933h-4c-1.7 0-3 1.271-3 2.933v.978H3c-1.7 0-3 1.27-3 2.932v9.776c0 1.662 1.3 2.933 3 2.933h13.975c1.7 0 3-1.27 3-2.933V6.843c0-1.661-1.3-2.932-3-2.932m-10-.978c0-.586.4-.977 1-.977h4c.6 0 1 .39 1 .977v.978h-6zm-5 13.686V6.843c0-.586.356-.977.89-.977h14.14a.99.99 0 0 1 1 .977v9.776a.99.99 0 0 1-1 .978H2.863c-.533 0-.888-.391-.888-.978"
    }, null, -1)
  ]))]))
}
export default { render: render }